import React from 'react';
import styles from '@/styles/components/question-builders/AddCustomQuestion.module.css';
import { ExpandableQuestion } from 'components/expandable/ExpandableQuestion';
import { QuestionOverlay } from './QuestionOverlay';
import plusIcon from '../../assets/plus_blue.svg';

export interface AddCustomQuestionData {
  id: string;
  onAddQuestion: () => void;
}

export const AddCustomQuestion: React.FC<AddCustomQuestionData> = props => {
  return (
    <div className={styles.customQuestionContainer}>
      <QuestionOverlay
        primaryActions={[
          {
            text: 'Add a custom question',
            icon: {
              source: plusIcon,
            },
            onClick: props.onAddQuestion,
          },
        ]}
        secondaryActions={[]}
      />
      <ExpandableQuestion
        id={props.id}
        title={'Question X'}
        subtitle="Custom"
        removeCompletion={() => {}}
        replaceCompletion={() => {}}
        swapCompletion={() => {}}
        previewContent={<div></div>} // TODO: add content placeholders here
        expandedContent={<div></div>}
        isExpanded={false}
        onExpand={() => {}}
      />
    </div>
  );
};
